module.exports = __webpack_public_path__ + "static/media/no_theme.6de2b73d.png";